import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// ==================== 审核模式配置 ====================
export function reviewModeList(data) {
  return axios.post(`${base.url}/business/regConfig/reviewMode/list`, qs.stringify(data))
}
export function reviewModeAddOrUpdate(data) {
  return axios.post(`${base.url}/business/regConfig/reviewMode/addOrUpdate`, qs.stringify(data))
}
export function reviewModeDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/regConfig/reviewMode/deleteBatchIds`, qs.stringify({ ids }))
}
export function reviewModeStatus(ids, status) {
  return axios.post(`${base.url}/business/regConfig/reviewMode/status`, qs.stringify({ ids, status }))
}

// ==================== 注册方式总开关配置 ====================
export function methodSwitchList(data) {
  return axios.post(`${base.url}/business/regConfig/methodSwitch/list`, qs.stringify(data))
}
export function methodSwitchAddOrUpdate(data) {
  return axios.post(`${base.url}/business/regConfig/methodSwitch/addOrUpdate`, qs.stringify(data))
}
export function methodSwitchDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/regConfig/methodSwitch/deleteBatchIds`, qs.stringify({ ids }))
}
export function methodSwitchStatus(ids, status) {
  return axios.post(`${base.url}/business/regConfig/methodSwitch/status`, qs.stringify({ ids, status }))
}

// ==================== 注册字段收集配置 ====================
export function fieldList(data) {
  return axios.post(`${base.url}/business/regConfig/field/list`, qs.stringify(data))
}
export function fieldAddOrUpdate(data) {
  return axios.post(`${base.url}/business/regConfig/field/addOrUpdate`, qs.stringify(data))
}
export function fieldDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/regConfig/field/deleteBatchIds`, qs.stringify({ ids }))
}
export function fieldStatus(ids, status) {
  return axios.post(`${base.url}/business/regConfig/field/status`, qs.stringify({ ids, status }))
}

// ==================== 国家注册配置 ====================
export function countryList(data) {
  return axios.post(`${base.url}/business/regConfig/country/list`, qs.stringify(data))
}
export function countryAddOrUpdate(data) {
  return axios.post(`${base.url}/business/regConfig/country/addOrUpdate`, qs.stringify(data))
}
export function countryDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/regConfig/country/deleteBatchIds`, qs.stringify({ ids }))
}
export function countryStatus(ids, status) {
  return axios.post(`${base.url}/business/regConfig/country/status`, qs.stringify({ ids, status }))
}

// ==================== 合并查询（无分页） ====================
export function getRegConfigByCountry(countryCode) {
  return axios.post(`${base.url}/business/regConfig/getByCountry`, qs.stringify({ countryCode }))
}

// ==================== 保存所有配置 ====================
export function saveRegConfigAll(data) {
  return axios.post(`${base.url}/business/regConfig/saveAll`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

// ==================== 交易组别展示配置单独保存 ====================
export function saveRegConfigTradeGroups(data) {
  return axios.post(`${base.url}/business/regConfig/saveTradeGroups`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}

// ==================== 交易组别展示图片上传 ====================
export function uploadTradeGroupImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  return axios.post(`${base.url}/cloud/qiniuUpload/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// ==================== 国家级别操作 ====================
export function disableCountry(countryCode) {
  return axios.post(`${base.url}/business/regConfig/disableCountry`, qs.stringify({ countryCode }))
}
export function deleteCountryConfig(countryCode) {
  return axios.post(`${base.url}/business/regConfig/deleteCountry`, qs.stringify({ countryCode }))
}